import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full bg-zinc-200" }
const _hoisted_2 = { class: "max-h-fit border lg:mx-56" }
const _hoisted_3 = { class: "p-2 lg:p-0 lg:mt-16 lg:mb-8" }
const _hoisted_4 = { class: "text-2xl font-bold" }
const _hoisted_5 = { class: "text-sm underline underline-offset-2" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "m-3 text-xl font-bold lg:mx-0" }, " Service Sélectionné", -1)
const _hoisted_8 = { class: "shadow-md p-4 my-1 bg-white rounded-lg" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "font-bold inline-block align-baseline" }
const _hoisted_12 = { class: "flex content-center" }
const _hoisted_13 = { class: "text-sm text-gray-600" }
const _hoisted_14 = { class: "pl-2 text-sm font-bold" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "pl-2 text-sm font-bold" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "mt-6 mb-3 font-bold" }, "Avec qui ?", -1)
const _hoisted_19 = { class: "grid md:grid-cols-3 gap-4 mx-4 mb-1" }
const _hoisted_20 = {
  key: 0,
  class: "m-3 text-xl font-bold"
}
const _hoisted_21 = {
  key: 1,
  class: "py-2 lg:grid grid-cols-5"
}
const _hoisted_22 = {
  key: 2,
  class: "flex w-full justify-center my-2"
}
const _hoisted_23 = { key: 3 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h1", { class: "my-3 text-xl font-bold" }, "Date et Heure sélectionnée", -1)
const _hoisted_25 = { class: "shadow-md p-6 my-1 bg-white rounded-lg" }
const _hoisted_26 = { class: "flex text-sm font-bold" }
const _hoisted_27 = { class: "pl-2 text-gray-500" }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h1", { class: "my-3 text-xl font-bold" }, "Pour", -1)
const _hoisted_30 = { class: "shadow-md p-6 my-1 bg-white rounded-lg" }
const _hoisted_31 = { class: "flex text-sm font-bold" }
const _hoisted_32 = { key: 5 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h1", { class: "my-3 text-xl font-bold" }, "Pas encore de compte?", -1)
const _hoisted_34 = { class: "shadow-md p-6 my-1 bg-white rounded-lg" }
const _hoisted_35 = {
  key: 6,
  class: "pb-3"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "mb-20" }, null, -1)

import { onMounted, ref,computed, onUnmounted } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useCurrentCompanyStore } from '../stores/CurrentCompanyStore'
  import { useReservationDaysStore } from '../stores/ReservationDaysStore'
  import { useUserStore } from '../stores/UserStore'
  import  DateHourGrid from "@/components/Reservation/DateHourGrid.vue"
  import  EmployeeButton from "@/components/Reservation/EmployeeButton.vue"
  import  LoginComponent from "@/components/Reservation/LoginComponent.vue"
  import { useRouter } from 'vue-router'
  import Modal from '@/components/Reservation/Modal.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ReservationPage',
  setup(__props) {

  const router = useRouter()

  const { allEvents, currentCompanyId,companyName,addressLine1,addressLine2,city,country,zipCode,employeesList,employeesHourList,selectedEventPrice,selectedEventDescription,selectedEventId,selectedEventDuration} = storeToRefs(useCurrentCompanyStore())
  let { nextThreeMonthsDays, hourSelected, hourCode, dateSelected, dateSelectedFull, employeeSelected } = storeToRefs(useReservationDaysStore())
  const {userEmail,userId } = storeToRefs(useUserStore())  
  const { filterEmployeeEvents, adjustEmployeeEventsWithDuration} = useReservationDaysStore()

  const itemsToShow = ref(15);

  const isModalVisible = ref(false);
  const openModal = () => {
    isModalVisible.value = true;
  };
  const closeModal = () => {
    isModalVisible.value = false;
  };
  let modalMessage= ref("")

  const visibleItems = computed(() => nextThreeMonthsDays.value.slice(0, itemsToShow.value));

  const loadMore = () => {
    itemsToShow.value += 15; // You can adjust this number as per your requirement
  };


  onUnmounted(()=>{
    hourSelected.value = null;
    dateSelected.value = null;
    hourCode.value = null;
    dateSelectedFull.value = null;
    employeeSelected.value = null;
    currentCompanyId.value =null;
  })


  let isSelected = ref(null);

  const selectEmployee = (employeeId) => {
    try{
      isSelected.value = employeeId === isSelected.value ? null : employeeId;
      filterEmployeeEvents(employeeId,allEvents.value,employeesHourList.value);
      adjustEmployeeEventsWithDuration(selectedEventDuration.value);
      employeeSelected.value = employeesList.value.find((event) => event.employeeId === isSelected.value);
    }
    catch(error){
      console.error(error)
    }
    
  }

  async function CreateEvent(){
    try {
        const response = await fetch(`${process.env.VUE_APP_API_BASE}/api/Event`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
              employeeId: isSelected.value,
              customerId: userId.value,
              eventType: selectedEventId.value,
              email:userEmail.value,
              sourceId: 0,
              companyId: currentCompanyId.value,
              active: true,
              scheduledAt: dateSelected.value,
              scheduledHourCode: hourCode.value,
              hourSelected:hourSelected.value,
              companyName:companyName.value,
              employeeName:employeeSelected.value.firstName             
            })
        });

        if (response.ok) {
          //alert("OK")
          isModalVisible.value=true;
          modalMessage.value= "Réservation confirmée !"
          
        } else {
            const errorMessage = await response.text();
            console.error(`Request failed with status ${response.status}: ${errorMessage}`);
            modalMessage.value= "Échec. Veuillez réessayer dans quelques minutes"
            //message.value = errorMessage;
        }
    } catch (error) {
        console.error(error);
    }
  }


  function deleteEvent(){
    alert("supprimer");
  }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(companyName)), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(addressLine1)) + ", " + _toDisplayString(_unref(zipCode)) + " " + _toDisplayString(_unref(city)) + ", " + _toDisplayString(_unref(country)), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("button", { onClick: openModal }),
          _createVNode(Modal, {
            "is-visible": isModalVisible.value,
            onClose: closeModal
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, [
                _createElementVNode("span", {
                  textContent: _toDisplayString(_unref(modalMessage))
                }, null, 8, _hoisted_6)
              ])
            ]),
            _: 1
          }, 8, ["is-visible"])
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(selectedEventDescription)), 1),
            _createElementVNode("button", {
              onClick: deleteEvent,
              class: "text-sm px-3 py-1 bg-black text-white rounded-lg"
            }, "Modifier")
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(selectedEventDuration) * 15) + "min", 1),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(selectedEventPrice)) + " $", 1),
            (_unref(hourSelected) !==null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, " avec " + _toDisplayString(_unref(employeeSelected).firstName), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_unref(hourSelected)===null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(employeesList), (it) => {
                  return (_openBlock(), _createBlock(EmployeeButton, {
                    key: it.employeeId,
                    firstName: it.firstName,
                    onClick: ($event: any) => (selectEmployee(it.employeeId)),
                    class: _normalizeClass({ 'border rounded-lg border-gray-600': _unref(isSelected) === it.employeeId })
                  }, null, 8, ["firstName", "onClick", "class"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(hourSelected) === null && _unref(employeeSelected) !==null)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_20, "Choix de la date & heure"))
        : _createCommentVNode("", true),
      (_unref(hourSelected) === null && _unref(employeeSelected) !==null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (it) => {
              return (_openBlock(), _createElementBlock("div", {
                key: it.date
              }, [
                _createVNode(DateHourGrid, {
                  date: it.date,
                  dayName: it.dayName,
                  dayMonth: it.dayMonth,
                  day: it.day,
                  events: it.events
                }, null, 8, ["date", "dayName", "dayMonth", "day", "events"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (visibleItems.value.length >0 && itemsToShow.value < _unref(nextThreeMonthsDays).length && _unref(hourSelected)==null && _unref(employeeSelected) !==null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("button", {
              class: "px-4 w-full bg-gray-800 text-white border shadow-md rounded-lg",
              onClick: loadMore
            }, "+")
          ]))
        : _createCommentVNode("", true),
      (_unref(hourSelected)!==null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", null, _toDisplayString(_unref(dateSelectedFull)), 1),
                _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(hourSelected)), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(hourSelected)!==null && _unref(userEmail)!==null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("p", null, _toDisplayString(_unref(userEmail)), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(hourSelected)!==null && _unref(userEmail)===null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _createVNode(LoginComponent)
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(hourSelected)!==null && _unref(userEmail)!==null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", { class: "flex justify-center" }, [
              _createElementVNode("button", {
                class: "text-sm my-10 px-5 py-2 bg-black text-white rounded-md",
                onClick: CreateEvent
              }, " Confirmer ")
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_36
    ])
  ]))
}
}

})